import { render, staticRenderFns } from "./codroomManage.vue?vue&type=template&id=af7c2b0e"
import script from "./codroomManage.vue?vue&type=script&lang=js"
export * from "./codroomManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports